import styled from 'styled-components';
import { spacing } from '../global/spacing.styles';
import { themedBackground, themedColor } from '../global/theme.styles';

export const StyledPage = styled.div`
    ${themedBackground};
    ${themedColor};
    padding-top: ${spacing.pageTopPadding}px;
`;
